import { styled, alpha } from "@mui/material/styles";
import { Grid } from "@mui/material";
import { Theme } from "@fullcalendar/react";
import { themeSlice } from "src/_globalStore/redux/reducers/Theme/ThemeSlice";

export const Container = styled(Grid)({
  width: "100%",
  position: "relative",
  height: "100%",
});

export const Overlay = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "error" && prop !== "opaqueBKG",
})<{ error?: boolean; opaqueBKG: boolean }>(
  ({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: alpha(theme.palette.background.default, 0.5),
    zIndex: 999,
  }),
  ({ error, theme }) => ({
    ...(error && {
      backgroundColor: alpha(theme.palette.background.default, 0.9),
    }),
  }),
  ({ opaqueBKG, theme }) => ({
    ...(!opaqueBKG && {
      backgroundColor: theme.palette.background.default,
    }),
  })
);
